import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

// Componentes
import { LoginComponent } from './pages/login/login.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { HomeComponent } from './pages/home/home.component';
import { UsersComponent } from './pages/users/users.component';
import { AccountStatusComponent } from './pages/account-status/account-status.component';
import { SearchInvoicesComponent } from './pages/search-invoices/search-invoices.component';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AvatarModule } from 'ng2-avatar';
import { NgSelectModule, NG_SELECT_DEFAULT_CONFIG } from '@ng-select/ng-select';
import { ToasterModule, ToasterService } from 'angular5-toaster';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// providers
import { NgxMaskModule } from 'ngx-mask';
import { MockBackend } from '@angular/http/testing';
import { BaseRequestOptions } from '@angular/http';
import { StorageService } from './services/storage.service';
import { AuthenticationService } from './services/authentication.service';
import { SearchInvoicesService } from './services/search-invoices.service';
import { UsersService } from './services/admin/users.service';
import { AccountStatusService } from './services/account-status/account-status.service';

import { AuthGuard } from './guards/auth-guard';
import { FormRegisterComponent } from './pages/users/form-register/form-register.component';
import { ChangePassComponent } from './pages/home/changepassword/changepassword.component';
import { FilterPipe } from './pipes/filter.pipe';
import { FilterSpPipe } from './pipes/filter-sp.pipe';
import { FiltersComponent } from './common/filters/filters.component';
import { RecuperarPassModalComponent } from './pages/login/recuperarPassword/recuperarPass.component';
import { ResponseModalComponent } from './components/response-modal/response-modal.component';
import { ResponseModal2Component } from './components/response-modal2/response-modal2.component';


import { ngfModule, ngf } from 'angular-file';
import { DialogComponent } from './components/dialog/dialog.component';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { FilterUserDialogComponent } from './components/filter-user-dialog/filter-user-dialog.component';
import { LogoutComponent } from './components/logout/logout.component';

// import ngx-translate and the http loader
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { StorageServiceModule } from 'angular-webstorage-service';
import { SendFilesComponent } from './pages/account-status/send-files/send-files.component';
import { DownloadFilesComponent } from './pages/account-status/download-files/download-files.component';
import { InicioComponent } from './pages/inicio/inicio.component';

// encriptación
import { CryptoInterceptor } from './security/crypto.interceptor';
import { CryptoService } from './security/crypto.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ToolbarComponent,
    HomeComponent,
    UsersComponent,
    FormRegisterComponent,
    AccountStatusComponent,
    FilterPipe,
    FilterSpPipe,
    LoadingIndicatorComponent,
    FiltersComponent,
    DialogComponent,
    LoadingIndicatorComponent,
    FilterUserDialogComponent,
    ChangePassComponent,
    RecuperarPassModalComponent,
    ResponseModalComponent,
    ResponseModal2Component,
    SearchInvoicesComponent,
    LogoutComponent,
    SendFilesComponent,
    DownloadFilesComponent,
    InicioComponent
  ],
  imports: [
    NgbModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxDatatableModule,
    AvatarModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ToasterModule,
    ngfModule,
    BrowserAnimationsModule,
    PdfViewerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMaskModule.forRoot(),
    StorageServiceModule
  ],
  providers: [
    StorageService,
    AuthGuard,
    MockBackend,
    BaseRequestOptions,
    AuthenticationService,
    SearchInvoicesService,
    UsersService,
    CryptoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CryptoInterceptor,
      multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: NG_SELECT_DEFAULT_CONFIG,
      useValue: {
        notFoundText: 'No hay resultados',
        loadingText: '...',
      },
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    FormRegisterComponent,
    FilterUserDialogComponent,
    ChangePassComponent,
    RecuperarPassModalComponent,
    ResponseModalComponent,
    ResponseModal2Component,
    LogoutComponent,
    SendFilesComponent,
    DownloadFilesComponent
  ]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts